document.addEventListener('DOMContentLoaded', () => {
	const scrollBtn = document.querySelector('.scroll-to-top')
	const handleScrollBtn = () => {
		if (window.scrollY > 500) {
			scrollBtn.classList.add('scroll-to-top--active')
		} else {
			scrollBtn.classList.remove('scroll-to-top--active')
		}
	}

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
		})
	}

	window.addEventListener('scroll', handleScrollBtn)
	scrollBtn.addEventListener('click', scrollToTop)
	window.addEventListener('scroll', () => {
		document.querySelector('.nav').classList.toggle('scrolled', window.scrollY > 60)
	})
})
